import { render, staticRenderFns } from "./CountryPage.vue?vue&type=template&id=02af7572&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02af7572')) {
      api.createRecord('02af7572', component.options)
    } else {
      api.reload('02af7572', component.options)
    }
    module.hot.accept("./CountryPage.vue?vue&type=template&id=02af7572&", function () {
      api.rerender('02af7572', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuration/countries/CountryPage.vue"
export default component.exports